/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React from 'react'
import { TAP_BTN_EVENT } from '@components/MainWidget/FastagWidget/constants'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { fetchWidgetProductFn, widgetJourney } from '@configs/segmentEvents.config'
import { WidgetType } from '@enums/WidgetType'
import styles from './DesktopChallanPPED.module.scss'
import DaysLeftRing from './DaysLeftRing'
import DesktopChallanList from './DesktopChallanList'
import NoChallanFound from './NoChallanFound'
import { type ChallanListItem } from './DesktopChallanCard'

const VERIFIED_BADGE_SRC = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/image_332_e9f0da2521.webp'

export type { ChallanListItem } from './DesktopChallanCard'

export type DesktopChallanModalPPEDProps = {
  regNum: string
  challanList?: ChallanListItem[]
  expiryDate?: string
  daysLeft?: number
  onSubmit?: () => void
  onViewAllChallans?: () => void
  segmentEventCommonProperties?: any
  widgetType?: string
  vehicleInfoData?: any
}

const DesktopChallanModalPPED = ({
  regNum,
  challanList = [],
  expiryDate,
  daysLeft,
  onViewAllChallans,
  segmentEventCommonProperties,
  widgetType = WidgetType.CHALLAN_WIDGET_LANDING,
  vehicleInfoData,
}: DesktopChallanModalPPEDProps) => {
  const hasChallans = challanList.length > 0
  const handleCheckPrice = () => {
    const redirect = () => {
      window.location.href = `/t/car?carNumber=${regNum}`
    }
    trackEvent(TAP_BTN_EVENT, {
      ...segmentEventCommonProperties,
      journey: widgetJourney?.[widgetType],
      product: fetchWidgetProductFn?.[widgetType]?.(),
      phone: vehicleInfoData?.mobile_number || '',
      registration_number: vehicleInfoData?.reg_number || '',
      cta_text: 'check price',
      action_type: 'redirection',
      redirection_url: '/t/car',
    })
      .then(redirect)
      .catch(redirect)
  }
  return (
    <div className={styles.desktopChallanModalPPED}>
      <div className={styles.leftModalContent}>
        <div className={styles.leftContentInner}>
          <div className={styles.ppedHeader}>
            <div className={styles.ppedHeaderLeft}>
              <div className={styles.ppedTitle}>Your challan details</div>
              <div className={styles.ppedVehicleName}>{vehicleInfoData?.vehicleInfo?.db_make_name} {vehicleInfoData?.vehicleInfo?.db_model_name}</div>
              <div className={styles.numberPlate}>
                <div className={styles.numberPlateBadge}>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="9" height="9" rx="4.5" stroke="white" strokeLinejoin="round" strokeDasharray="1 2" />
                    <rect x="3" y="3" width="4" height="4" rx="1" fill="url(#paint0_linear_desktop_pped_plate)" />
                    <rect width="2" height="2" transform="translate(4 4)" fill="#E7E7F0" />
                    <defs>
                      <linearGradient id="paint0_linear_desktop_pped_plate" x1="3.5" y1="3" x2="6.5" y2="7" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="0.0001" stopColor="white" />
                        <stop offset="0.505" stopColor="#FFF8F8" />
                        <stop offset="1" stopColor="white" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <div className={styles.numberPlateInd}>IND</div>
                </div>
                <div className={styles.numberPlateValue}>{regNum}</div>
              </div>
              {/* <div className={styles.ppedTitle}>Your challan details</div> */}
            </div>
            <img height={80} alt="verified" src={VERIFIED_BADGE_SRC} className={styles.verifiedBadge} />
          </div>

          {hasChallans ? (
            <DesktopChallanList
              challanList={challanList}
              onViewAllChallans={onViewAllChallans}
              segmentEventCommonProperties={segmentEventCommonProperties}
              widgetType={widgetType}
              vehicleInfoData={vehicleInfoData}
            />
          ) : (
            <NoChallanFound />
          )}
        </div>
      </div>

      <div className={styles.rightModalContent}>
        <div className={styles.rightContentInner}>
          <div className={styles.rightTopRow}>
            <div className={styles.rightCopy}>
              <div className={styles.rightHeadline}>
                Check your ACKO insurance
                <br />
                price and save big!
              </div>
              {expiryDate && <div className={styles.rightExpiry}>Your insurance expire{daysLeft && daysLeft > 0 ? 's' : 'd'} on {expiryDate}</div>}
            </div>
            {daysLeft != null && <DaysLeftRing daysLeft={daysLeft} />}
          </div>

          <div className={styles.featureCards}>
            <div className={styles.featureCard}>
              <img src="https://acko-cms.ackoassets.com/zero_commission_icon_8c978c7e09_1_b367727534.svg" />
              <div className={styles.featureCardText}>Commission-free <br /> prices</div>
            </div>
            <div className={styles.featureCard}>
              <img src="https://acko-cms.ackoassets.com/Frame_7eff0dc73b.svg" />
              <div className={styles.featureCardText}>Cashless repairs <br />
                at any garage</div>
            </div>
          </div>

          <button type="button" className={styles.ppedCta} onClick={handleCheckPrice}>
            Check your price
          </button>
        </div>
      </div>
    </div>
  )
}

export default DesktopChallanModalPPED
